module.exports = __webpack_public_path__ + "img/zfr1.b3af3511.jpg";